import React from "react";
import Modal from "react-bootstrap/Modal";
import { X } from "lucide-react";

const EditFaqsModal = ({ show, onHide, editForm, setEditForm, onSave }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body style={{ padding: "24px", background: "#FFFFFF", borderRadius: "24px" }}>
                <div style={{ display: 'flex', flexDirection: "row-reverse", justifyContent: "space-between", marginBottom: '24px' }}>
                    <X onClick={onHide} style={{ cursor: "pointer" }} />
                    <span style={{ fontFamily: "ClashDisplay-Semibold", fontSize: "24px", lineHeight: "32px" }}>Edit FAQ</span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    <div>
                        <label style={{ fontWeight: 400, fontSize: 14, color: "#6B7280" }}>Question</label>
                        <input
                            type="text"
                            value={editForm.question}
                            onChange={(e) => setEditForm({ ...editForm, question: e.target.value })}
                            style={{
                                width: "100%",
                                padding: "16px",
                                borderRadius: "16px",
                                border: "1px solid #E5E7EB",
                                background: "#F9FAFB",
                                outline: "none"
                            }}
                        />
                    </div>
                    <div>
                        <label style={{ fontWeight: 400, fontSize: 14, color: "#6B7280" }}>Answer</label>
                        <textarea
                            value={editForm.answer}
                            onChange={(e) => setEditForm({ ...editForm, answer: e.target.value })}
                            style={{
                                width: "100%",
                                padding: "16px",
                                borderRadius: "16px",
                                border: "1px solid #E5E7EB",
                                background: "#F9FAFB",
                                minHeight: "100px",
                                outline: "none"
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={onHide} style={{ flex: 1, padding: '12px', border: '1px solid #9CA3AF', borderRadius: '27px', background: 'white', color: '#9CA3AF', cursor: 'pointer' }}>
                            Cancel
                        </button>
                        <button onClick={onSave} style={{ flex: 1, padding: '12px', background: '#23b4c3', borderRadius: '27px', color: 'white', border: 'none', cursor: 'pointer' }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EditFaqsModal;
